export class ChangePassword {
    data: ChangePasswordObject
    constructor(init: ChangePasswordObject) {
        this.data = init
    }
}
interface ChangePasswordObject {
    oldPassword: string
    newPassword: string
    userName: string
}